import { useCallback, useEffect, useState } from "react";

/**
 * Shared sort state for data tables (toggle asc/desc on same column; new column starts asc).
 * Matches useEntityListChrome / StockManagement table sort behavior.
 *
 * @param {{ key: string|null, direction: 'asc'|'desc' }} initialSort
 * @param {unknown} [resetWhen] When this value changes, sort resets to initialSort
 */
export function useTableSort(initialSort = { key: null, direction: "asc" }, resetWhen) {
  const [sortConfig, setSortConfig] = useState(initialSort);

  useEffect(() => {
    if (resetWhen === undefined) return;
    setSortConfig(initialSort);
  }, [resetWhen, initialSort]);

  const handleSort = useCallback((key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  }, []);

  return { sortConfig, setSortConfig, handleSort };
}
